const stocks = [
  'for_sale',
  'sold',
]

export { stocks }
